import { showError, showSuccess } from "./toast";

/**
 * Map API / thunk error payloads to a user-facing message.
 * Never treat declined/forbidden responses as success.
 */
export function getApiErrorMessage(errorOrPayload, fallback = "Something went wrong") {
  const status =
    errorOrPayload?.status ||
    errorOrPayload?.response?.status ||
    errorOrPayload?.payload?.status;

  const raw =
    errorOrPayload?.message ||
    errorOrPayload?.payload?.message ||
    errorOrPayload?.response?.data?.error ||
    errorOrPayload?.response?.data?.message ||
    errorOrPayload?.error ||
    errorOrPayload?.payload?.error;

  const message = typeof raw === "string" ? raw : fallback;
  const accessDenied =
    status === 403 ||
    errorOrPayload?.accessDenied ||
    errorOrPayload?.payload?.accessDenied ||
    /access denied/i.test(String(message));

  if (accessDenied) {
    return message && !/^access denied$/i.test(message)
      ? message
      : "You are not authorized to perform this action";
  }
  if (status === 401) return message || "Please sign in again";
  if (status === 404) return message || "Resource not found";
  if (status === 400) return message || "Invalid request";
  if (status >= 500) return message || "Server error. Please try again later";
  if (!navigator.onLine) return "Network error. Check your connection and try again";

  return message || fallback;
}

export function notifyApiError(errorOrPayload, fallback) {
  showError(getApiErrorMessage(errorOrPayload, fallback));
}

/** Only call this after a confirmed successful (2xx) response. */
export function notifyApiSuccess(message) {
  if (message) showSuccess(message);
}
